import { Link } from "gatsby"
import React, { useState } from "react"

import "./header.less"

export default () => {
  const d = new Date()
  const year = d.getFullYear()

  return (
    <footer>
      <div className={"container"}>
        <div className="row">
          <div className="col-lg-12">
            <Link to={"/"} className={"home-link"}>
              <img
                src={require("../images/white-logo.svg").default}
                alt="Workplace One"
              />
            </Link>
            <div className="row">
              {/*<Newsletter className={"d-lg-none"} />*/}
              <div className="col-sm-6 col-md-3">
                <h5 className={"d-none d-md-block"}>Community</h5>
                <ul>
                  <li>
                    <Link to={"/blog"}>Blog</Link>
                  </li>
                  <li>
                    <Link to={"/upcoming-events"}>Upcoming Events</Link>
                  </li>
                </ul>
              </div>

              <div className="col-sm-6 col-md-3">
                <h5 className={"d-none d-md-block"}>Partnerships</h5>
                <ul>
                  <li>
                    <Link to={"/brokers"}>Brokers</Link>
                  </li>
                  <li>
                    <Link to={"/plan-an-event"}>Plan an Event</Link>
                  </li>
                  <li>
                    <Link to={"/service-partners"}>Service Partners</Link>
                  </li>
                </ul>
              </div>

              <div className="col-sm-6 col-md-3">
                <h5 className={"d-none d-md-block"}>Explore</h5>
                <ul>
                  <li className={"d-none d-md-block"}>
                    <Link to={"/solutions"}>Solutions</Link>
                  </li>
                  <li className={"d-none d-md-block"}>
                    <Link to="/locations?location=Toronto&onboard=true">
                      Find Space
                    </Link>
                  </li>
                  <li className={"d-none d-md-block"}>
                    <Link to={"/locations"}>All Locations</Link>
                  </li>
                  <li>
                    <Link to={"/meeting-rooms"}>Meeting Rooms</Link>
                  </li>
                </ul>
              </div>

              <div className="col-sm-6 col-md-3">
                <h5 className={"d-none d-md-block"} />
                <ul>
                  <li>
                    <Link to={"/contact"}>Contact Us</Link>
                  </li>
                  <li>
                    <a href={`tel:+14166457045`}>(416) 645 - 7045</a>
                  </li>
                  <li>
                    <Link to={"/safety-policies"}>COVID-19 Response</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/*<Newsletter className={"d-none d-lg-block"} />*/}
        </div>

        <div className="row">
          <div className="col-sm-12">
            <hr />
          </div>

          <div className="col-lg-6 text-lg-end d-lg-none">
            <SocialIcons />
            <br />
            <a
              href={
                "https://workplaceone.yardikube.com/member/content/login#/appaccess/login"
              }
              target={"_blank"}
              rel={"noopener noreferrer"}
              className={"link"}
            >
              Member Login
            </a>
            <Link to={"/privacy-policy"} className={"link"}>
              Privacy Policy
            </Link>
          </div>

          <div className="col-lg-6">
            <p className="copyright">
              &copy; {year} Workplace One Business Centres Limited
            </p>
          </div>
          <div className="col-lg-6 text-lg-end d-none d-lg-block">
            <a
              href={
                "https://workplaceone.yardikube.com/member/content/login#/appaccess/login"
              }
              target={"_blank"}
              rel={"noopener noreferrer"}
              className={"link"}
            >
              Member Login
            </a>
            <Link to={"/privacy-policy"} className={"link"}>
              Privacy Policy
            </Link>

            <SocialIcons />
          </div>
        </div>
      </div>
    </footer>
  )
}

const SocialIcons = ({ className = "" }) => {
  return (
    <ul className={"footer-social " + className}>
      <li>
        <a
          href={"https://www.facebook.com/workplace.one"}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          <img
            src={require("../images/icons/social-facebook.svg").default}
            alt="Facebook Profile"
          />
        </a>
      </li>
      <li>
        <a
          href={"http://instagram.com/workplaceone/"}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          <img
            src={require("../images/icons/social-instagram.svg").default}
            alt="Instagram Profile"
          />
        </a>
      </li>
      <li>
        <a
          href={"https://twitter.com/WorkplaceOne"}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          <img
            src={require("../images/icons/social-twitter.svg").default}
            alt="Twitter Profile"
          />
        </a>
      </li>
      <li>
        <a
          href={"https://www.linkedin.com/company/workplaceone/"}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          <img
            src={require("../images/icons/social-linked-in.svg").default}
            alt="LinkedIn Profile"
          />
        </a>
      </li>
    </ul>
  )
}

const Newsletter = ({ className = "" }) => {
  const [email, setEmail] = useState("")

  const subscribe = (e) => {
    e.preventDefault()
  }

  return (
    <div className={"col-lg-4 " + className}>
      <h4>Join our newsletter</h4>
      <form action="#" onSubmit={subscribe}>
        <input
          type="text"
          className="form-control"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={"Email"}
        />
        <button className={"btn"}>Go</button>
      </form>
    </div>
  )
}
